/**
 * This directory's own copy: the hints on the balance figures, the funded-
 * window card, and the shed-accounts table's column headers. Everything
 * else this area renders comes from the shared `tt` catalogue
 * (`src/app/tenant/i18n`) unchanged.
 */

import { defineCatalogue } from '../../../i18n';

export const balanceCatalogue = defineCatalogue(
  {
    'hint.total': 'Tudo o que a organização tem, incluindo o que já está reservado.',
    'hint.held': 'Guardado para o acompanhamento que já está em andamento.',
    'hint.available': 'O que ainda dá para usar em novas contas.',
    'window.title': 'Até onde os créditos cobrem',
    'window.until': 'Acompanhando até',
    'window.toHorizon': 'Créditos para cobrir tudo',
    'window.funded': 'Contas acompanhadas',
    'window.shed': 'Contas de fora',
    'window.none': 'Ainda não',
    'window.unpriced': 'Sob consulta',
    'shed.handle': 'Conta',
    'shed.platform': 'Rede',
    'shed.rate': 'Custo por hora',
    'month.opening': 'Saldo no início do mês',
    'month.added': '+ Adicionados',
    'month.spent': '− Gastos',
    'month.available': 'Disponível',
    'month.summary':
      'Saldo no início do mês {opening}, adicionados {added}, gastos {spent}, disponível {available} ({percent})',
    'month.label': 'Créditos disponíveis neste mês',
  },
  {
    'hint.total': 'Everything the organisation has, including what is already set aside.',
    'hint.held': 'Kept for the following already under way.',
    'hint.available': 'What is still there to spend on new accounts.',
    'window.title': 'How far the credits reach',
    'window.until': 'Following until',
    'window.toHorizon': 'Credits to cover it all',
    'window.funded': 'Accounts followed',
    'window.shed': 'Accounts left out',
    'window.none': 'Not yet',
    'window.unpriced': 'On request',
    'shed.handle': 'Account',
    'shed.platform': 'Network',
    'shed.rate': 'Cost per hour',
    'month.opening': 'Balance at month start',
    'month.added': '+ Added',
    'month.spent': '− Spent',
    'month.available': 'Available',
    'month.summary':
      'Balance at month start {opening}, added {added}, spent {spent}, available {available} ({percent})',
    'month.label': 'Credits available this month',
  },
);

export const bm = balanceCatalogue.t;
